import { GameOrientationEnum } from '../../types/enum';

// Todo: HUZ2ERA-1105 - Just update the values for these games in our CMS.
export const HARDCODED_GAMES = [
  {
    code: 'gd-la-times-daily-crossword-sg',
    orientation: GameOrientationEnum.PORTRAIT,
    // src: 'https://games.softgames.com/games/la-times-daily-crossword/gamesites/99999/locale/',
  },
  {
    code: 'gd-thomas-joseph-crossword',
    orientation: GameOrientationEnum.PORTRAIT,
    // src: 'https://games.softgames.com/games/thomas-joseph-crossword/gamesites/99999/locale/',
  },
  {
    code: 'gd-jumble-crossword-daily-sg',
    orientation: GameOrientationEnum.PORTRAIT,
    // src: 'https://games.softgames.com/games/jumble-crossword-daily/gamesites/99999/locale/',
  },
  {
    code: 'gd-jumble-crossword-sunday-sg',
    orientation: GameOrientationEnum.PORTRAIT,
    // src: 'https://games.softgames.com/games/jumble-crossword-sunday/gamesites/99999/locale/',
  },
  {
    code: 'gd-la-times-sunday-crossword-sg',
    orientation: GameOrientationEnum.PORTRAIT,
    // src: 'https://games.softgames.com/games/la-times-sunday-crossword/gamesites/99999/locale/',
  },
  {
    code: 'gd-premier-sunday-crossword-sg',
    orientation: GameOrientationEnum.PORTRAIT,
    // src: 'https://games.softgames.com/games/premier-sunday-crossword/gamesites/99999/locale/',
  },
  {
    code: 'gd-daily-commuter-crossword-sg',
    orientation: GameOrientationEnum.PORTRAIT,
    // src: 'https://games.softgames.com/games/daily-commuter-crossword/gamesites/99999/locale/',
  },
  {
    code: 'gd-eugene-sheffer-crossword-sg',
    orientation: GameOrientationEnum.PORTRAIT,
    // src: 'https://games.softgames.com/games/eugene-sheffer-crossword/gamesites/99999/locale/',
  },
  {
    code: 'gd-micro-crossword-sg',
    orientation: GameOrientationEnum.PORTRAIT,
    // src: 'https://games.softgames.com/games/micro-crossword/gamesites/99999/locale/',
  },
  {
    code: 'gd-observer-crossword-sg',
    orientation: GameOrientationEnum.PORTRAIT,
    // src: 'https://games.softgames.com/games/observer-crossword/gamesites/99999/locale/',
  },
  {
    code: 'gd-tv-crossword-sg',
    orientation: GameOrientationEnum.PORTRAIT,
    // src: 'https://games.softgames.com/games/tv-crossword/gamesites/99999/locale/',
  },
  {
    code: 'gd-candy-mahjong-sg',
    orientation: GameOrientationEnum.PORTRAIT,
  },
  {
    code: 'gd-mahjong-frenzy-sg',
    orientation: GameOrientationEnum.PORTRAIT,
  },
  {
    code: 'gd-candy-rain-sg',
    orientation: GameOrientationEnum.PORTRAIT,
  },
  {
    code: 'gd-cookie-crush-sg',
    orientation: GameOrientationEnum.PORTRAIT,
  },
  {
    code: 'gd-2020-connect-sg',
    orientation: GameOrientationEnum.PORTRAIT,
  },
  {
    code: 'gd-2020-plus-sg',
    orientation: GameOrientationEnum.PORTRAIT,
  },
  {
    code: 'gd-2048-lines-sg',
    orientation: GameOrientationEnum.PORTRAIT,
  },
  {
    code: 'gd-maya-sg',
    orientation: GameOrientationEnum.PORTRAIT,
  },
];